import {cloneDeep} from "lodash";
import Moment from "moment";
import React, { Component } from "react";
import {SubsidiaryUtils} from "../../../../../../utils/Subsidiary/SubsidiaryUtils";
import { AuthActionCreators } from "../../../../actions/actionCreators";
import { connect } from "react-redux";
import { Role, ROLE_ACTIONS } from "../RolesListPage.component";
import { checkAuthorization } from "../../../../../../utils/Authorization/authorization";
import { AuthAPIRoutes } from "../../../../api/auth.apiRoutes";
import "./RoleCard.component.scss";
import { authStoreSelectors } from "../../../../store/store";

export interface RoleCardProps {
    role_obj: Role;
    open_popup: any;
    open_dialog: any;
    subsidiaries: any;
}

class RoleCard extends Component<RoleCardProps> {
    constructor(props) {
        super(props);
        this.handleCardEditButtonClick = this.handleCardEditButtonClick.bind(
            this
        );
        this.handleCardDetailsButtonClick = this.handleCardDetailsButtonClick.bind(
            this
        );
        this.handleCardTrashButtonClick = this.handleCardTrashButtonClick.bind(
            this
        );
    }

    handleCardEditButtonClick(e) {
        let role = cloneDeep(this.props.role_obj)
        role.subsidiaries = role.in ? role.in.map(sub => sub.subsidiary) : []
        this.props.open_popup(e, {
            drawer_title: "Edit Role",
            role_obj: role,
            form_button_name: "Save",
            current_role_routes_obj: {},
            role_action: ROLE_ACTIONS.EDIT_ROLE
        });
    }

    handleCardDetailsButtonClick(e) {
        let role = cloneDeep(this.props.role_obj)
        role.subsidiaries = role.in ? role.in.map(sub => sub.subsidiary) : []
        this.props.open_popup(e, {
            drawer_title: "Role",
            role_obj: role,
            form_button_name: "",
            current_role_routes_obj: {},
            role_action: ROLE_ACTIONS.DETAILS_ROLE
        });
    }

    handleCardTrashButtonClick(e) {
        this.props.open_dialog(e, {
            dialog_message: "Are you sure you want to delete this Role?",
            role_action: ROLE_ACTIONS.DELETE_ROLE,
            role_id: this.props.role_obj.in.map(i => i.id)
        });
    }

    render() {
        return (
            <div className="role-card" key={this.props.role_obj.id}>
                <div className="role-card-header">
                    <div className="role-card-header-info">
                        <div className="username user-card-info block-display">
                            <span>{this.props.role_obj.name}</span>
                        </div>
                        <span className="user-creation-date block-display">
                            Created on{" "}
                            {Moment(this.props.role_obj.created).format(
                                "DD MMMM, YYYY"
                            )}
                        </span>
                    </div>
                </div>
                {this.props.role_obj.editable &&
                    <div className="role-card-body">
                    <label className="label">Subsidiaries</label>
                    <div className="subsidiaries-block">
                        {this.props.role_obj.in && this.props.role_obj.in.length > 0 ? (
                            this.props.role_obj.in.map(sub => {
                                const subsidiary =
                                    this.props.subsidiaries.find(
                                        subd => subd.id == sub.subsidiary
                                    );
                                if (subsidiary) {
                                    return (
                                        <div key={sub.id}>
                                            {SubsidiaryUtils.subsidiaryIcon(subsidiary)}
                                            <div className="messages">
                                                <label className="label">
                                                    {subsidiary.description}
                                                </label>
                                            </div>
                                        </div>
                                    );
                                }
                            })
                        ) : (
                            <div className="no-subs">-</div>
                        )}
                    </div>
                </div>}
                <div className="role-card-footer">
                    <div className="role-card-footer-left">
                       {checkAuthorization({
                            route: AuthAPIRoutes.EDIT_ROLE
                        }) &&
                            this.props.role_obj.editable && (
                                <button
                                    className="role-card-footer-button"
                                    onClick={this.handleCardEditButtonClick}
                                >
                                    Edit
                                </button>
                            )}

                        {!this.props.role_obj.editable && (
                            <button
                                className="role-card-footer-button"
                                onClick={this.handleCardDetailsButtonClick}
                            >
                                Details
                            </button>
                        )}
                    </div>
                    <div className="role-card-footer-right">
                      {checkAuthorization({
                            route: AuthAPIRoutes.DELETE_ROLE
                        }) && this.props.role_obj.editable && (
                                <div
                                    className="btn_icon icon-del icon-del tooltip-icon"
                                    onClick={this.handleCardTrashButtonClick}
                                >
                                    <span className="tooltip-text">Delete</span>
                                    <i className="icon-trash-alt-light" />
                                </div>
                            )}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    subsidiaries: authStoreSelectors.subsidiaries(state)
});

const mapDispatchToProps = {
    deleteRole: AuthActionCreators.deleteRole,
    getUsers: AuthActionCreators.getUsers
};

export default connect(mapStateToProps, mapDispatchToProps)(RoleCard);
